import React from 'react'
import { CrossClientResultSourceIcon } from '../Sources/CrossClientResultSourceIcon'
import { getCrossClientResultSourceLabel } from '../Sources/utils'
import { CrossClientQueryDataSource } from '../../../../models/CrossClient'

interface CrossClientDataSourcesProps {
  sources: CrossClientQueryDataSource[]
}

export const CrossClientDataSources: React.FC<CrossClientDataSourcesProps> = ({ sources }) => {
  return (
    <>
      <h6>Data sources:</h6>
      <div className='d-flex flex-column gap-2'>
        {sources.map((source, idx) => (
          <div key={idx} className='d-flex gap-2 align-items-center'>
            <CrossClientResultSourceIcon source={source} />
            <div className='paragraph-small'>{getCrossClientResultSourceLabel(source)}</div>
          </div>
        ))}
      </div>
    </>
  )
}
